import { Fragment, type ReactNode } from 'react';
import type { ProntuarioNotesRenderChunk } from './buildProntuarioNotesDisplayModel';

const renderChunk = (
	chunk: ProntuarioNotesRenderChunk,
	key: number,
): ReactNode => {
	if (chunk.kind === 'plain') {
		if (chunk.text === '\n') return '\n';

		if (chunk.text === '• ') {
			return (
				<Fragment key={key}>
					<span className="text-slate-400">•</span>
					<span> </span>
				</Fragment>
			);
		}

		return <Fragment key={key}>{chunk.text}</Fragment>;
	}

	if (chunk.kind === 'delim') {
		return (
			<span key={key} className="text-slate-400/85">
				{chunk.text}
			</span>
		);
	}

	if (chunk.kind === 'bold') {
		return (
			<span
				key={key}
				className="font-normal text-slate-50 [text-shadow:0.55px_0_0_currentColor,-0.55px_0_0_currentColor]"
			>
				{chunk.text}
			</span>
		);
	}

	if (chunk.kind === 'italic') {
		return (
			<em key={key} className="font-normal italic text-slate-200">
				{chunk.text}
			</em>
		);
	}

	return (
		<span
			key={key}
			className="font-normal text-emerald-200/90 underline decoration-emerald-400/40 decoration-1 underline-offset-[3px]"
		>
			{chunk.text}
		</span>
	);
};

export const renderProntuarioNotesPreview = (
	chunks: ProntuarioNotesRenderChunk[],
): ReactNode => chunks.map((chunk, index) => renderChunk(chunk, index));
